import { notificationActions } from 'src/actions/actionTypes'

const initialState = {
  type: null,
  message: null,
}

const notificationReducer = (state = initialState, action) => {
  if (action.type === notificationActions.SHOW_NOTIFICATION) {
    return {
      ...state,
      type: action.payload.type,
      message: action.payload.message,
    }
  } else {
    return state
  }
}
export default notificationReducer
